<template>
    <a class="anchor">
        <h2 class="subtitle">
            <img class="ornament" src="../../public/img/logo/left.png"/>
            <span> {{ title }} </span>
            <img class="ornament" src="../../public/img/logo/right.png"/>
        </h2>
    </a>
</template>

<script>
export default {
    props: {
        title: { type: String, required: true }
    }
}
</script>

<style lang="scss" scoped>
@import "./variables.scss";

.anchor {
    display: block;
    position: relative;
    top: -70px;
    z-index: -10;
}

.ornament {
    @media screen and (max-width: 300px ) {
        display: none;
    }
}

.subtitle {
    display: flex;
    font-size: 50px;
    font-weight: normal; 
    margin: 0.8em 0 0.5em;
    top: 70px;
    position: relative;
    align-items: center;
    justify-content: center;
    font-family: 'Dancing Script', Arial, sans-serif;
    @media screen and (max-width: $break-sm) {
        font-size: 40px;
    }
}
</style>

